import { createContext, useContext } from 'react';
export const WorkspaceReadyContext = createContext<() => void>(() => undefined);
export const useWorkspaceReady = () => useContext(WorkspaceReadyContext);
